"use client";
import { createBrowserClient } from "@supabase/ssr";

// Cliente Supabase pra Client Components — usa anon key + cookies da session.
// Necessário pra subscriptions Realtime, que rodam só do navegador.
export function createBrowserSupabaseClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}
